import type { InferResponseType } from "hono/client";
import { z } from "zod";
import type { api } from "@/client/lib/api";

/** The Show menu's rows, in the frame's order. A payslip notice has no row, so nothing hides it. */
export const INBOX_CATEGORIES = [
  "mentions",
  "assigned",
  "comments",
  "done",
  "foreday",
  "due",
  "leave",
] as const;

const inboxCategory = z.enum(INBOX_CATEGORIES);

/** Anything unreadable falls back to the whole inbox rather than refusing the screen. */
export const inboxSearch = z.object({
  unread: z.literal(true).optional().catch(undefined),
  hide: z.array(inboxCategory).optional().catch(undefined),
  item: z.string().optional().catch(undefined),
});

/**
 * Notices to mark read or unread: one, or every one Mark all read covers. The cap is well past the
 * 200 the inbox lists plus what arrives while it is open, and far under Postgres's bind limit.
 */
export const noticeIdsInput = z.object({
  ids: z.array(z.string().min(1)).min(1).max(1_000),
});

/** One notice as `GET /api/inbox` answers it; a leave notice carries its ask. */
export type InboxItem = InferResponseType<
  typeof api.inbox.$get,
  200
>["items"][number];

export interface InboxTask {
  readonly title: string;
  readonly dueOn: string | null;
  readonly dueTime: string | null;
}

export type InboxCategory = z.infer<typeof inboxCategory>;
export type InboxSearch = z.infer<typeof inboxSearch>;
